import React, { useEffect, useState  } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { classNames } from 'primereact/utils';
import { useParams } from 'react-router-dom';
import axiosWithAuth from '../../helpers/AxiosHelper';
import errorMessage from '../../helpers/errorMessage';
import { ToggleButton } from 'primereact/togglebutton';
import { SelectButton } from 'primereact/selectbutton';
import _, { join as array_join, has, isNil } from 'lodash';
import { InputTextarea } from 'primereact/inputtextarea';
import * as Yup from 'yup';
import { Chips } from 'primereact/chips';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../../hooks/useAuth';
import { ConfirmPopup } from 'primereact/confirmpopup';
import PageHeader from '../common/PageHeader';
import './platforms.css';
const downloadsTemplate = (rowData) => {
    return <span >{array_join(rowData.downloads, ',')}</span>;
}

const group_options = [
    { 'label': 'Admin', 'value': 'Admin' },
    { 'label': 'ECS', 'value': 'ECS' },
    { 'label': 'Analytics', 'value': 'Analytics' }
]

const platform_analytics_columns = [
    {
        header: 'Tab Title',
        field: 'title'
    },
    {
        header: 'IFrame Title',
        field: 'iframe_title'
    },
    {
        header: 'PowerBI URL',
        field: 'url',
    },
    {
        header: 'Groups',
        field: 'group',
    },
    {
        header: 'Downloads',
        field: 'downloads',
        body: downloadsTemplate
    }
]

const emptyAnalyticsTab = {
    id: null,
    title: '',
    iframe_title: '',
    url: '',
    group: '',
    downloads: []
}

export const PlatformConfiguration = (props) => {
    const [visible, setVisible] = useState(false);
    const [didAnalyticsChange,setdidAnalyticsChange] = useState(false)

    const navigate = useNavigate();

    const { platform,updatePlatformConfig } = useAuth()

    const { platformName } = useParams()

    const data_ypes_options = [
        { 'name': 'SME', 'value': 'SME' },
        { 'name': 'Consumer', 'value': 'CONSUMER' },
        { 'name': 'ECS', 'value': 'ECS' },
        { 'name': 'Cash Flows', 'value': 'CASH_FLOWS' },
        { 'name': 'Opportunities', 'value': 'OPPORTUNITIES' },
        { 'name': 'Loan Applications', 'value': 'APPLICATIONS' },
        {   'name': 'Invoices', 'value': 'INVOICE_FINANCING' },
        { 'name': 'Investor Slice', 'value': 'INVESTOR_SLICE' }
    ]

    const [platformConfig, setPlatformConfig] = useState({
        validate: false,
        spro_upload: false,
        map_data: false,
        data_types: [],
        invoice_allocations: [],
        platform_analytics: [],
        platform: '',
        _key: ''
    })
    // This platform's invoice allocations in LoanSweeper, offered when
    // configuring which ones invoice uploads can go to.
    const [lsAllocations, setLsAllocations] = useState(null);
    const [platformAnalyticsSingle, setPlatformAnalyticsSingle] = useState(emptyAnalyticsTab);
    const [analyticsDialog, setAnalyticsDialog] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    // const [showMessage, setShowMessage] = useState(false);
    // const [formData, setFormData] = useState({});

    useEffect(() => {
        axiosWithAuth.get(`/platforms/${platformName}`).then((response) => {
            let data = response.data[0];
            setPlatformConfig({
                validate: data['validate'],
                spro_upload: data['spro_upload'],
                map_data: data['map_data'],
                data_types: data['data_types'],
                invoice_allocations: data['invoice_allocations'] || [],
                platform_analytics: data['platform_analytics'],
                platform: data['platform'],
                _key: data['_key']
            });
        }).catch((err) => {
            alert(errorMessage(err));
        })
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const formik = useFormik({
        initialValues: {
            validate: platformConfig.validate,
            spro_upload: platformConfig.spro_upload,
            map_data: platformConfig.map_data,
            data_types: platformConfig.data_types,
            invoice_allocations: platformConfig.invoice_allocations,
            platform_analytics: platformConfig.platform_analytics
        },
        validationSchema: Yup.object({
            validate: Yup.bool().required('Required').default(true),
            spro_upload: Yup.bool().required('Required').default(false),
            map_data: Yup.bool().required('Required').default(false),
            data_types: Yup.array().required('Required'),
            invoice_allocations: Yup.array().of(Yup.object({
                allocation_id: Yup.string().required('Pick an allocation'),
                name: Yup.string().trim().required('Enter a name')
            }))
        }),
        onSubmit: (data) => {
            props.setLoading(true);

            data['platform'] = platformConfig.platform;
            data['_key'] = platformConfig._key;
            // console.log(data);

            axiosWithAuth.post(`/platforms/${platformName}`, data).then((response) => {
                let updated_data = response.data.data;
                setPlatformConfig(updated_data)
                if (platform === platformName){
                updatePlatformConfig(updated_data)
                }
                
            }).catch((err) => {
                alert(errorMessage(err));
            }).finally(() => {
                props.setLoading(false);
            })
            // setFormData(data);
            setdidAnalyticsChange(false)
            // setShowMessage(true);
            formik.resetForm();
        },
        enableReinitialize: true
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const invoices_enabled = (formik.values.data_types || []).includes('INVOICE_FINANCING');
    const [lsAllocationsError, setLsAllocationsError] = useState(null);

    useEffect(() => {
        if (!invoices_enabled || lsAllocations !== null) return;
        axiosWithAuth.get(`/activity/platforms/${encodeURIComponent(platformName)}/allocations`).then((response) => {
            if (response.data.unavailable) setLsAllocationsError('LoanSweeper is not reachable right now.');
            setLsAllocations((response.data.allocations || []).filter((a) => a.loan_type === 'INVOICE_FINANCING'));
        }).catch((err) => {
            setLsAllocationsError(errorMessage(err));
            setLsAllocations([]);
        });
    }, [invoices_enabled]); // eslint-disable-line react-hooks/exhaustive-deps

    const invoice_allocations = formik.values.invoice_allocations || [];
    const setInvoiceAllocations = (rows) => formik.setFieldValue('invoice_allocations', rows);
    const updateInvoiceAllocation = (index, changes) =>
        setInvoiceAllocations(invoice_allocations.map((row, i) => (i === index ? { ...row, ...changes } : row)));
    const invoiceAllocationError = (index, field) =>
        formik.touched.invoice_allocations?.[index]?.[field] && formik.errors.invoice_allocations?.[index]?.[field];
    // Each LoanSweeper allocation can be configured once; a configured one that
    // is no longer in LoanSweeper stays listed so it can be seen and removed.
    const invoiceAllocationOptions = (current) => {
        const taken = invoice_allocations.map((row) => row.allocation_id).filter((id) => id !== current);
        const options = (lsAllocations || []).filter((a) => !taken.includes(a.key))
            .map((a) => ({ label: `${a.name} (${a.key})${a.active ? '' : ' - inactive'}`, value: a.key }));
        if (current && !options.some((o) => o.value === current)) {
            options.unshift({ label: `${current} (not found in LoanSweeper)`, value: current });
        }
        return options;
    };

    const dynamicColumns = platform_analytics_columns.map((col, i) => {
        return <Column key={col.field} field={col.field} header={col.header} body={col.body} sortable={col.sortable} editor={col.editor} style={col.style} />
    })

    const editAnalyticsTab = (platform_analytics_row) => {
        setPlatformAnalyticsSingle({ ...platform_analytics_row });
        setSubmitted(false);
        setAnalyticsDialog(true);
    }

    const isBlank = function(value) {
        return _.isEmpty(value) || _.isNil(value)
    }

    const validateAnalyticsData = (platform_analytics_single) => {
        if (isBlank(platformAnalyticsSingle.title)||isBlank(platformAnalyticsSingle.iframe_title)||isBlank(platformAnalyticsSingle.url)||isBlank(platformAnalyticsSingle.group))
            return false;
        return true;
    }

    const onAddOrEditAnalyticsTab = () => {
        setSubmitted(true);
        let _platform_analytics_updated =  formik.values.platform_analytics;
        let _platformAnalyticsSingle = platformAnalyticsSingle;
        if (validateAnalyticsData(_platformAnalyticsSingle)) {

            if (has(platformAnalyticsSingle, 'id') && !isNil(platformAnalyticsSingle.id)) {
                let index = -1;
                for (let i = 0; i < _platform_analytics_updated.length; i++) {
                    if (_platform_analytics_updated[i].id === _platformAnalyticsSingle.id) {
                        index = i;
                        break;
                    }
                }
                _platform_analytics_updated[index] = _platformAnalyticsSingle;
            } else {
                _platformAnalyticsSingle.id = createId();
                _platform_analytics_updated.push(_platformAnalyticsSingle);
            }
            formik.setFieldValue('platform_analytics', _platform_analytics_updated).then((daz) => {formik.setFieldTouched('platform_analytics',true);setdidAnalyticsChange(true);}).catch(() => {});
            hideDialog();

        }

    }

    const createId = () => {
        let id = '';
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 8; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }


    const hideDialog = () => {
        setPlatformAnalyticsSingle(emptyAnalyticsTab);
        setSubmitted(false);
        setAnalyticsDialog(false);
    }
    const analyticsDialogFooter = (
        <React.Fragment>
            <Button type="button" label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button type="button" label="Save" icon="pi pi-check" className="p-button-text" onClick={onAddOrEditAnalyticsTab} />
        </React.Fragment>
    );

    const openNew = () => {
        setPlatformAnalyticsSingle(emptyAnalyticsTab);
        setSubmitted(false);
        setAnalyticsDialog(true);
    }

    // Delete Dialog Stuff

    const onDeleteAnalyticsTab = () => {
        let _platform_analytics_updated = formik.values.platform_analytics.filter(val => val.id !== platformAnalyticsSingle.id);
        setPlatformAnalyticsSingle(emptyAnalyticsTab);
        formik.setFieldValue('platform_analytics', _platform_analytics_updated);
        setDeleteDialog(false);
    }

    const hideDeleteDialog = () => {
        setPlatformAnalyticsSingle(emptyAnalyticsTab);
        setDeleteDialog(false);
    }


    const deleteAnalyticsTabDialogFooter = (
        <React.Fragment>
            <Button type="button" label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button type="button" label="Yes" icon="pi pi-check" className="p-button-text" onClick={onDeleteAnalyticsTab} />
        </React.Fragment>
    );


    const confirmDeleteAnalytics = (platform_analytics_row) => {
        setPlatformAnalyticsSingle({ ...platform_analytics_row });
        setDeleteDialog(true);
    }


    const table_header = (
        <div className="table-header platform-config-table-header">
            <h5 className="ex-section-title">Analytics Tab</h5>
            <Button type="button" label="New" icon="pi pi-plus" className="p-button-success" onClick={openNew} />
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editAnalyticsTab(rowData)} />
                <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteAnalytics(rowData)} />
            </React.Fragment>
        );
    }

    const MyToggleButton = ({
        label,
        name,
        value,
        handleChange,
        ...props
    }) => (<div className="field platform-config-toggle">
        {/* <InputText id="name" name="name" value={formik.values.name} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('name') })} /> */}
        <label htmlFor={name} className={classNames('platform-config-toggle-label', { 'p-error': isFormFieldValid(name) })}>{label}</label>
        <ToggleButton id={name} name={name} checked={value} onIcon="pi pi-check" offIcon="pi pi-times" onChange={handleChange} {...props} />

    </div>);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _platformAnalyticsSingle = { ...platformAnalyticsSingle };
        _platformAnalyticsSingle[`${name}`] = val;

        setPlatformAnalyticsSingle(_platformAnalyticsSingle);
    }

    const accept = () => {
        navigate(-1);
    };

    const reject = () => {
        // alert('rejet')
        setVisible(false)
    };

    const goBack = () => {
        if (formik.dirty || didAnalyticsChange){
            setVisible(true)
        }else
            navigate(-1);
    }

    const msg = () => (
        <span>
            You might have unsaved changes.
            <br></br>
            <br></br>
            Are you sure you want to proceed?
        </span>
    )


    return (
        <div className="content-container">
            <div style={{ maxWidth: "100%" }}>

                <form onSubmit={formik.handleSubmit} className="platform-config-form">

                    <PageHeader
                        title={platformConfig.platform}
                        subtitle="Originator configuration"
                        icon="pi-cog"
                        actions={
                            <React.Fragment>
                                <Button id='go-back-simon' type='button' label='Back' icon="pi pi-arrow-left" className='p-button-text' onClick={goBack}/>
                                <ConfirmPopup target={document.getElementById('go-back-simon')} visible={visible} onHide={() => setVisible(false)} message={msg}
                            icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />
                                <Button type='button' label='Users' icon='pi pi-users' className='p-button-secondary p-button-outlined' onClick={() => navigate(`/platforms/${platformName}/users`)} />
                                <Button type='button' label='API Access' icon='pi pi-key' className='p-button-secondary p-button-outlined' onClick={() => navigate(`/platforms/${platformName}/api-access`)} />
                                <Button type='submit' label='Submit' icon='pi pi-save'/>
                            </React.Fragment>
                        }
                    />

                    <section className="ex-section">
                        <div className="ex-section-header">
                            <div>
                                <h3 className="ex-section-title">Data processing</h3>
                                <div className="ex-section-subtitle">What happens to files uploaded for this Originator.</div>
                            </div>
                        </div>
                        <div className="platform-config-toggles">
                            <MyToggleButton label='Basic Validation' name="validate" handleChange={formik.handleChange} value={formik.values.validate} />
                            <MyToggleButton label='Upload to S-Pro' name="spro_upload" handleChange={formik.handleChange} value={formik.values.spro_upload} />
                            <MyToggleButton label='Map Data' name="map_data" handleChange={formik.handleChange} value={formik.values.map_data} />
                        </div>
                        <div className="field platform-config-datatypes mb-0">
                            <label htmlFor='data_types' className={classNames('platform-config-field-label', { 'p-error': isFormFieldValid('data_types') })}>Supported Data Types</label>
                            <SelectButton id='data_types' name='data_types' optionLabel="name" value={formik.values.data_types} options={data_ypes_options} onChange={formik.handleChange} multiple></SelectButton>
                        </div>
                        {invoices_enabled && (
                            <div className="field platform-config-allocations mb-0">
                                <label className="platform-config-field-label">Invoice allocations</label>
                                <small className="block mb-2">LoanSweeper allocations that invoice uploads for this Originator can go to. Uploaders pick one; if there is only one, it is used automatically.</small>
                                {lsAllocations === null && <small className="block mb-2">Loading allocations from LoanSweeper…</small>}
                                {lsAllocationsError && <small className="p-error block mb-2">Couldn't load allocations from LoanSweeper: {lsAllocationsError}</small>}
                                {lsAllocations !== null && !lsAllocationsError && lsAllocations.length === 0 && (
                                    <small className="block mb-2">LoanSweeper has no invoice allocations for this Originator.</small>
                                )}
                                {invoice_allocations.map((row, index) => (
                                    <div key={index} className="platform-config-allocation-row">
                                        <span>
                                            <Dropdown value={row.allocation_id} options={invoiceAllocationOptions(row.allocation_id)} placeholder="LoanSweeper allocation"
                                                className={classNames({ 'p-invalid': invoiceAllocationError(index, 'allocation_id') })}
                                                onChange={(e) => updateInvoiceAllocation(index, {
                                                    allocation_id: e.value,
                                                    name: row.name || lsAllocations?.find((a) => a.key === e.value)?.name || ''
                                                })} />
                                            {invoiceAllocationError(index, 'allocation_id') && <small className="p-error block">{invoiceAllocationError(index, 'allocation_id')}</small>}
                                        </span>
                                        <span>
                                            <InputText value={row.name} placeholder="Name shown to uploaders, e.g. E98"
                                                className={classNames({ 'p-invalid': invoiceAllocationError(index, 'name') })}
                                                onChange={(e) => updateInvoiceAllocation(index, { name: e.target.value })} />
                                            {invoiceAllocationError(index, 'name') && <small className="p-error block">{invoiceAllocationError(index, 'name')}</small>}
                                        </span>
                                        <Button type="button" icon="pi pi-trash" className="p-button-text p-button-danger" tooltip="Remove"
                                            onClick={() => setInvoiceAllocations(invoice_allocations.filter((_row, i) => i !== index))} />
                                    </div>
                                ))}
                                <Button type="button" label="Add allocation" icon="pi pi-plus" className="p-button-text p-button-sm"
                                    disabled={!lsAllocations?.length || invoice_allocations.length >= lsAllocations.length}
                                    onClick={() => setInvoiceAllocations([...invoice_allocations, { allocation_id: '', name: '' }])} />
                            </div>
                        )}
                    </section>

                    <section className="ex-section">
                        <DataTable value={formik.values.platform_analytics} showGridlines dataKey="id" header={table_header}
                            paginator paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={5} rowsPerPageOptions={[5, 10, 20, 50]} responsiveLayout="scroll" stripedRows sortField="update_date"
                        >
                            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '10rem' }}></Column>
                            {dynamicColumns}

                        </DataTable>
                    </section>

                    <Dialog visible={analyticsDialog} style={{ width: '450px' }} header="Add New/Edit Analytics Tab" modal className="p-fluid" footer={analyticsDialogFooter} onHide={hideDialog}>
                        <div className="field">
                            <label htmlFor="title">Title</label>
                            <InputText id="title" value={platformAnalyticsSingle.title} onChange={(e) => onInputChange(e, 'title')} required autoFocus className={classNames({ 'p-invalid': submitted && !platformAnalyticsSingle.title })} />
                            {submitted && !platformAnalyticsSingle.title && <small className="p-error">Title is required.</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="iframe_title">Iframe Title</label>
                            <InputText id="iframe_title" value={platformAnalyticsSingle.iframe_title}  onChange={(e) => onInputChange(e, 'iframe_title')} required autoFocus className={classNames({ 'p-invalid': submitted && !platformAnalyticsSingle.iframe_title })} />
                            {submitted && !platformAnalyticsSingle.iframe_title && <small className="p-error">Iframe Title is required.</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="url">URL</label>
                            <InputTextarea id="url" value={platformAnalyticsSingle.url} onChange={(e) => onInputChange(e, 'url')} required rows={3} cols={10} className={classNames({ 'p-invalid': submitted && !platformAnalyticsSingle.url })} />
                            {submitted && !platformAnalyticsSingle.url && <small className="p-error">URL is required.</small>}
                        </div>

                        <div className="field">
                            <label htmlFor="groups">AWS Group</label>
                            <Dropdown id='group' value={platformAnalyticsSingle.group} options={group_options} required onChange={(e) => onInputChange(e, 'group')} placeholder="Select a Group" className={classNames({ 'p-invalid': submitted && !platformAnalyticsSingle.group })} />
                            {submitted && !platformAnalyticsSingle.group && <small className="p-error">Group is required.</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="downloads">Downloads</label>
                            <Chips id='downloads' value={platformAnalyticsSingle.downloads} onChange={(e) => onInputChange(e, 'downloads')} tooltip="Add AWS s3 URLs for different downloads."></Chips>
                        </div>
                    </Dialog>

                    <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Delete Analytics Tab" modal className="p-fluid" footer={deleteAnalyticsTabDialogFooter} onHide={hideDialog}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {platformAnalyticsSingle && <span>Are you sure you want to delete <b>{platformAnalyticsSingle.title}</b>?</span>}
                        </div>
                    </Dialog>
                </form>
            </div>
        </div>
    );
}